import styled from 'foundations-theming/utils';
export const FontOption = styled.span.withConfig({
  displayName: "FontOption",
  componentId: "sc-1mx7o44-0"
})(({
  fontFamily,
  cssStyles
}) => {
  return Object.assign({
    fontFamily
  }, cssStyles);
});